import resources from '../resource.js';

const resource = 'companies-house';

export default {
    index(id, companyNumber) {
        return resources.get(`${resource}/${id}/lookup/${companyNumber}`);
    }
}
